import React, { FC, useMemo } from 'react';
import { OneWayInOpportunitySimpleV2Dto } from 'src/api/v2';
import { Card } from '@innovationnorway/cl-react';
import classNames from 'classnames';
import css from './DeliveredServicesStatCard.module.scss';
import { useTranslation } from 'react-i18next';

type Props = {
  opportunityList: OneWayInOpportunitySimpleV2Dto[];
};

const DeliveredServicesStatCard: FC<Props> = ({ opportunityList }) => {
  const { t: tOneWayIn } = useTranslation('oneWayIn');
  const opportunitiesWithServices = useMemo(() => {
    return opportunityList.filter((o) => o.deliveredServices!.length > 0);
  }, [opportunityList]);

  const percentage = (opportunitiesWithServices.length / opportunityList.length) * 100;

  const firstValueColor = useMemo(() => {
    if (percentage === 0) return css.red;
    if (percentage > 0 && percentage <= 50) return css.yellow;
    if (percentage > 50) return css.green;
    return '';
  }, [percentage]);

  return (
    <Card variant="tinted" data-color={'neutral' as const}>
      <p>{tOneWayIn('opportunity.activeWithDeliveredServices')}</p>
      <p>
        <span className={classNames(css['first-value'], firstValueColor)}>
          {opportunitiesWithServices.length}
        </span>
        <span className={css['second-value']}>/{opportunityList.length}</span>
      </p>
    </Card>
  );
};

export default DeliveredServicesStatCard;
